<template>
   <div>
       <div class="base-div">
			<div class="base-title">
				<h1 v-if="activityType==1">活动介绍</h1>
				<h1 v-if="activityType==2">赛道介绍</h1>
				<span></span>
			</div>
			<div class="flex">
				<div class="base-desc" style="width: 45%">
					<p v-html="activeInfo.content"></p>
				</div>
				<div class="notice-wrap">
					<div class="notice-title">
						<h3>公告栏</h3>
						<router-link to="/noticelist"><span>更多 ></span></router-link>
					</div>
					<ul class="notice-list">
						<li @click="toDetail(item.id)" v-for="item in noticeList" :key="item.id">
							<div class="notice-time">
								<span></span>
								<p>{{item.addTimeStr}}</p>
							</div>
							<div class="notice-cnt">
								{{item.title}}
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="base-div">
			<div class="base-title">
				<h1>奖项设置</h1>
				<span></span>
			</div>
			<div class="base-desc">
				<p>{{activeInfo.prizeExplain}}</p>
			</div>
			<div class="prize-list-wrap" v-if="activityType==1">
				<ul class="clearfix">
					<li class="prize-list">
						<div class="prize-item">
							<img class="prize-item-img" src="../../../assets/prize_01.png" alt="月度奖" />
							<img class="prize-item-icon" src="../../../assets/prize_icon_01.png"/>
						</div>
						<div class="prize-cnt">
							<h4>个人奖项：</h4>
							<ul>
								<li v-html="activeInfo.personalMonthPrize"></li>
							</ul>
							<h4>单位奖项：</h4>
							<ul>
								<li v-html="activeInfo.companyMonthPrize"></li>
							</ul>
						</div>
					</li>
					<li class="prize-list">
						<div class="prize-item">
							<img class="prize-item-img" src="../../../assets/prize_02.png" alt="季度奖" />
							<img class="prize-item-icon prize-item-icon2" src="../../../assets/prize_icon_02.png"/>
						</div>
						<div class="prize-cnt">
							<h4>个人奖项：</h4>
							<ul>
								<li v-html="activeInfo.personalQuarterPrize"></li>
							</ul>
							<h4>单位奖项：</h4>
							<ul>
								<li v-html="activeInfo.companyQuarterPrize"></li>
							</ul>
						</div>
					</li>
					<li class="prize-list">
						<div class="prize-item">
							<img class="prize-item-img" src="../../../assets/prize_03.png" alt="年度奖" />
							<img class="prize-item-icon prize-item-icon3" src="../../../assets/prize_icon_03.png"/>
						</div>
						<div class="prize-cnt">
							<h4>个人奖项：</h4>
							<ul>
								<li v-html="activeInfo.personalYearPrize"></li>
							</ul>
							<h4>单位奖项：</h4>
							<ul>
								<li v-html="activeInfo.companyYearPrize"></li>
							</ul>
						</div>
					</li>
				</ul>
			</div>
			<div class="prize-list-wrap" v-else-if="activityType==2">
				<ul class="prize-dbw-item">
					<li :class="{'active': prizeType==1}" @click="changePrize(1)">适配奖项</li>
					<li :class="{'active': prizeType==2}" @click="changePrize(2)">测试奖项</li>
				</ul>
				<ul class="clearfix">
					<li class="prize-dbw-li" v-for="(item,index) in prizeList" :key="index">
						<div class="prize-dbw-txt">
							<h4>{{item.prizeName}}<span class="padleft15">X{{item.prizeNumber}}</span></h4>
							<p>{{item.prizeContent}}</p>
							<span class="prize-amount">¥ {{item.prizeAmount}}</span>
						</div>
						<img class="prize-dbw-img" :src="item.iconUrl" />
					</li>
				</ul>
			</div>
		</div>
		<div class="base-div">
			<div class="base-title">
				<h1>任务类型</h1>
				<span></span>
			</div>
			<div class="base-desc task-type-desc">
				<p>{{activeInfo.taskCategoryExplain}}</p>
				<ul class="task-type">
					<li>
						<img class="task-type-icon" src="../../../assets/intro_icon_01.png"/>
						<div class="task-type-txt">
							<h6 v-if="shipei&&shipei.categoryName">{{shipei.categoryName}}</h6>
							<p v-if="shipei&&shipei.categoryContent">{{shipei.categoryContent}}</p>
						</div>
					</li>
					<li>
						<img class="task-type-icon" src="../../../assets/intro_icon_02.png"/>
						<div class="task-type-txt">
							<h6 v-if="shipei&&shipei.categoryName">{{ceshi.categoryName}}</h6>
							<p v-if="ceshi&&ceshi.categoryContent">{{ceshi.categoryContent}}</p>
						</div>
					</li>
					<li>
						<img class="task-type-icon" src="../../../assets/intro_icon_03.png"/>
						<div class="task-type-txt">
							<h6 v-if="xuanshang&&xuanshang.categoryName">{{xuanshang.categoryName}}</h6>
							<p v-if="xuanshang&&xuanshang.categoryContent">{{xuanshang.categoryContent}}</p>
						</div>
					</li>
				</ul>
				<img class="task-r-img" :src="activeInfo.indexTaskUrl"/>
			</div>
		</div>
		<div class="base-div">
			<div class="base-title">
				<h1 v-if="activityType==1">活动评审</h1>
				<h1 v-if="activityType==2">赛道评审</h1>
				<i class="base-title-tips">（排名不分先后）</i>
				<span></span>
			</div>
			<div class="swiper-container" id="swiper-container1">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item1,index) in judgesList" :key="index">
						<ul class="review-list clearfix">
							<li :class="{'review-active': currentJudgeIndex==index}" v-for="(item,index) in judgesList[index]" :key="item.id" @click="showDetail(item,index)">
								<img class="review-img" :src="item.picUrl" />
								<div class="review-txt">
									<span class="review-name">{{item.judgesName}}</span>
									<span class="review-company">{{item.position}}</span>
								</div>
							</li>
						</ul>
						<ul class="review-single">
							<li>
								<img class="review-img" :src="singleJudgeInfo.picUrl" />
								<div class="review-txt">
									<span class="review-name" style="padding-bottom:5px">{{singleJudgeInfo.judgesName}}</span>
									<span class="review-company">{{singleJudgeInfo.position}}</span>
									<p style="margin-top: 15px; line-height:18px">{{singleJudgeInfo.content}}</p>
								</div>
							</li>
						</ul>
					</div>
				</div>
				<!-- <div v-if="judgesList.length>1" class="swiper-button-prev"></div>
				<div v-if="judgesList.length>1" class="swiper-button-next"></div> -->
				<div v-if="judgesList.length>1" class="swiper-pagination"></div>
			</div>
		</div>
		<div class="base-div">
			<div class="base-title">
				<h1>合作伙伴</h1>
				<i class="base-title-tips">（排名不分先后）</i>
				<span></span>
			</div>
			<div class="base-desc">
				<div class="swiper-container" id="swiper-container2">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in partnerList" :key="item.id">
							<ul class="partner-list clearfix">
								<li v-for="item in partnerList[index]" :key="item.id">
									<a v-if="item.officialUrl" :href="item.officialUrl" target="_blank"><img :src="item.picUrl"/></a>
									<img v-else :src="item.picUrl"/>
								</li>
							</ul>
						</div>
					</div>
					<!-- <div v-if="partnerList.length>1" class="swiper-button-prev"></div>
					<div v-if="partnerList.length>1" class="swiper-button-next"></div> -->
					<div v-if="partnerList.length>1" class="swiper-pagination"></div>
				</div>
			</div>
		</div>
   </div>
</template>
<script>
import Swiper from "swiper"
import 'swiper/dist/css/swiper.css'
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
export default {
    name: 'Introduce',
	data(){
		return {
			activeInfo: {},
			partnerList: [],
			judgesList: [],
			activityId: '',
			singleJudgeInfo: {},
			currentJudgeIndex: 0,
			shipei:{},
			ceshi: {},
			xuanshang: {},
			activityType: 1,  //活动类型 1共测 2大比武
			prizeType: 1,  //1适配 2测试
			prizeList: [],
			noticeList: []
		}
	},
	methods: {
		//获取公告列表
		async getNoticeList(){
			let url = 'v1/notice/list'
			let param = {
				activityId: this.activityId,
				pageNum: 1,
				pageSize: 4
			}
			ajaxParam(param)
			const res = await post(url, qs.stringify(param))
			if(res.data.code==200) {
				this.noticeList = res.data.list
			} else {
				this.$message.error(res.data.msg)
			}
		},
		toDetail(id){
			this.$router.push(`/noticedetail/${id}`)
		},
		//获取当前活动信息
		async getActiveInfo(){
			let url = 'v1/activity/getIndexActivity'
			let param = {
        activityId:this.activityId
      }
			const res = await post(url, param)
			if(res.data.code==200) {
				let entity = res.data.entity
				this.activeInfo = entity
				localStorage.setItem('activityId', entity.id)
				localStorage.setItem('activityType', entity.activityType)
				localStorage.setItem('activeInfo', JSON.stringify(entity))
				// localStorage.setItem('attachTask', entity.attachTask)
				// localStorage.setItem('attachTest', entity.attachTest)
				// localStorage.setItem('attachAdaptation', entity.attachAdaptation)
				this.activityId = entity.id
				this.shipei = res.data.shipei
				this.ceshi = res.data.ceshi
				this.xuanshang = res.data.xuanshang
				this.activityType = entity.activityType
				if(this.activityType==2){
					this.getActivityPrize()
				}
				this.getPartner()
				this.getJudges()
				this.getNoticeList()
			} else {
				this.$message.error(res.data.msg)
			}
		},
		changePrize(index){
			if(index==this.prizeList) return
			this.prizeType = index
			this.getActivityPrize()
		},
		//获取大比武奖项设置
		async getActivityPrize(){
			let url = 'v1/activity/getActivityPrize'
			let param = {
				activityId: this.activityId,
				prizeType : this.prizeType
			}
			ajaxParam(param)
			const res = await post(url, qs.stringify(param))
			if(res.data.code==200) {
				this.prizeList = res.data.list
			} else {
				this.$message.error(res.data.msg)
			}
		},
		//获取合作伙伴
		async getPartner(){
			let url = 'v1/activity/getActivityPartner'
			let param = {
				activityId: this.activityId
			}
			ajaxParam(param)
			const res = await post(url, qs.stringify(param))
			//console.log(res)
			if(res.data.code==200) {
				//this.partnerList = res.data.list
				this.partnerList=this.chunk(res.data.list, 10)
				setTimeout(()=>{
					this.initSwiper2()
				},300)
			} else {
				this.$message.error(res.data.msg)
			}
		},
		//获取评委列表
		async getJudges(){
			let url = 'v1/activity/getActivityJudges'
			let param = {
				activityId: this.activityId
			}
			ajaxParam(param)
			const res = await post(url, qs.stringify(param))
			//console.log(res)
			if(res.data.code==200) {
				this.judgesList=this.chunk(res.data.list, 8)
				//this.judgesList = res.data.list
				this.singleJudgeInfo = this.judgesList[0][0]
				setTimeout(()=>{
					this.initSwiper()
				},300)
			} else {
				this.$message.error(res.data.msg)
			}
		},
		chunk (arr, size) { // 遍历原始数据，每n条（每页显示条数）push进新数组
			var rsArr = [];
			for (var i = 0; i < arr.length; i += size) {
				var tempArr = [];
				for (var j = 0; j < size && i + j < arr.length; j++) {
				tempArr.push(arr[i + j]);
				}
				rsArr.push(tempArr);
			}
			return rsArr;
		},
		//显示评委详细信息
		showDetail(model,index){
			this.currentJudgeIndex = index
			this.singleJudgeInfo = model
		},
		initSwiper() {
			let that = this
			new Swiper("#swiper-container1", {
				//设置轮播的循环方式
				//loop: true,
				//设置自动播放间隔时间
				autoplay: false,
				// 轮播效果,默认为平滑轮播
				effect: "slide",
				//前进后退按钮
				// prevButton: ".swiper-button-prev",
				// nextButton: ".swiper-button-next",
				pagination: '.swiper-pagination',
				paginationClickable :true,
				// 用户中断轮播后续播
				autoplayDisableOnInteraction: false,
				onSlideChangeStart: function(swiper){
					//console.log(swiper.activeIndex)
					that.singleJudgeInfo = that.judgesList[swiper.activeIndex][0]
					that.currentJudgeIndex = 0
				},
			});
		},
		initSwiper2() {
			new Swiper("#swiper-container2", {
				//设置轮播的循环方式
				//loop: true,
				//设置自动播放间隔时间
				autoplay: 10000,
				// 轮播效果,默认为平滑轮播
				effect: "slide",
				//前进后退按钮
				// prevButton: ".swiper-button-prev",
				// nextButton: ".swiper-button-next",
				pagination: '.swiper-pagination',
				paginationClickable :true,
				// 用户中断轮播后续播
				autoplayDisableOnInteraction: false
			});
		},
	},
	mounted(){

	},
	created(){
    this.activityId=this.$route.query.id
		this.getActiveInfo()
	}
}
</script>
<style scoped>
.base-title{overflow: hidden; position:relative; display: flex;}
.base-title h1{font-size:26px;font-weight:bold;margin-bottom:2%;line-height:30px;}
.base-title span{display:inline-block;width:50px;height:3px;background:#cb000f;position:absolute;bottom:0;left:0;}
.base-title-tips{padding-top: 10px; color:#999}
.base-desc{width:100%; padding-top:20px; color:#333333;line-height:30px;text-align:justify;font-size:18px;}

.prize-list-wrap{margin-top: 40px}
.prize-list{float:left; width: 31.6%; margin-right:2.5%;}
.prize-list:last-of-type{margin-right:0;}
.prize-item{height: 54px; padding:0 8px; background:#DE0515}
.prize-item-img{float:left; width: 118px; height: 48px; margin-top: 3px}
.prize-item-icon{float:right; width: 40px; height: 48px; margin-top: 3px}
.prize-item-icon2{width:49px}
.prize-item-icon3{width:48px}
.prize-cnt{ background: #F7F7F7; padding: 10px 30px;}
.prize-cnt h4{font-size: 16px; color:#3a3a3a; line-height: 37px; font-weight: 800;}
.prize-cnt ul li{font-size: 12px;}

.review-wrap{position: relative;}
.review-list{width: 780px; float:left}
.review-list li{float: left; width:145px; margin-top: 44px; margin-right: 50px}
.review-img{width: 145px; height: 145px;}
.review-txt span{display: block; width: 100%; text-align: center; line-height: 15px; font-size: 12px;}
.review-txt span.review-name{padding: 12px 0 5px; line-height: 40px; font-size: 16px; font-weight: bold;}
.review-txt p{margin-top:10px; font-size: 12px; color:#878787; line-height: 15px;}
.review-company{ font-size: 10px;}
.review-list .review-company{height: 30px;}
.review-single{ float:right; width:300px; margin-top: 20px}
.review-single .review-img{width: 300px; height: 300px}
.review-single .review-txt span.review-name{font-size: 18px;}
.review-active{}

.partner-list{padding-bottom: 20px}
.partner-list li{float:left; margin-bottom: 10px; position: relative; width: 20%; height: 100px}
.partner-list li img {position:absolute;top:0;bottom:0;left:0;right:0;margin:auto;max-width:150px;max-height:95px;z-index:9;}

.prize-dbw-item{display: flex; margin-bottom: 20px}
.prize-dbw-item li{min-width: 48px; height: 18px; margin-right: 30px; padding-bottom:5px; font-size: 12px; font-weight: bold; color: #000;line-height: 18px; cursor: pointer;}
.prize-dbw-item li.active{border-bottom: 2px solid #000}
.prize-dbw-li{float: left; width: 49%; margin-bottom: 8px; background: #F7F7F7; display: flex; justify-content: space-between;}
.prize-dbw-li:nth-of-type(2n){margin-left: 2%}
.prize-dbw-txt{display: flex; flex-direction: column; padding: 20px; position: relative; color: #000; }
.prize-dbw-txt h4{margin-bottom: 10px; font-weight: bold; font-size: 24px; line-height: 36px;}
.prize-dbw-txt p{font-size:11px; color: #7F7F7F; line-height: 16px;}
.prize-amount{position: absolute; bottom:20px;font-size: 18px; font-weight: 400;line-height: 27px;}
.prize-dbw-img{width: 137px; height: 184px;}
/*任务类型 */
.task-type-desc{width:55%}
.task-r-img{position:absolute; right:0; top:40px; width: 32%;}
.task-type li{position: relative; margin-top: 50px}
.task-type-icon{width:53px; height: 48px; position:absolute; left:0; top:0}
.task-type-txt{margin-left: 80px}
.task-type-txt h6{padding-bottom:10px; font-size: 16px; line-height: 25px; font-weight: bold;}
.task-type-txt p{color:#848484; font-size: 14px; line-height: 26px;}
.swiper-container ::v-deep .swiper-pagination-bullet-active{
      background-color: #cb000f;
}
#swiper-container1{height: 600px}
.padleft15{padding-left:15px}
.flex{display: flex; justify-content: space-between;}
.notice-wrap{width: 45%; margin-top: -50px; position: relative;}
.notice-title{padding: 0 0 10px; border-bottom: 1px solid #000; display: flex; justify-content: space-between;}
.notice-title h3{font-size: 16px;}
.notice-title span{font-size: 12px;}
.notice-list li{margin-top: 8px; cursor: pointer;}
.notice-time{display: flex; align-items: center; font-size: 11px;}
.notice-time span{display:block; width:4px; height: 4px; margin-right: 10px; border-radius:50%; background: #F50105;}
.notice-cnt{height: 27px; margin-left: 14px; padding-left:10px; background: #F7F7F7; line-height: 27px; font-size: 13px;}
</style>
